export const keys = {
    all: ["compressorlynx-summary"],
    summaryDatas: () => [
        ...keys.all,
        "summary-data"
    ],
    summaryData: (groupID: number) => [
        ...keys.summaryDatas(),
        {
            groupID
        }
    ]
};
